module.exports = __webpack_public_path__ + "static/media/credit-conso-picto.ee1c4fe7.svg";